module.exports = "pegasus/assets/frame-large-twitter.png";